import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "base-page grid-box grid-col",
  id: "kennel"
}
const _hoisted_2 = { class: "cal-container scroll-y" }
const _hoisted_3 = { class: "selectors" }
const _hoisted_4 = { class: "option" }
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["KennelCalendar"], {
        timeframe: $setup.timeframe,
        "onUpdate:timeframe": _cache[2] || (_cache[2] = ($event: any) => (($setup.timeframe) = $event)),
        kennel: $setup.selectedSize
      }, {
        "header-left": _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedSize) = $event)),
                class: _normalizeClass($setup.selectedSize)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.Dogspaces.Sizes, (size) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: size,
                    value: size
                  }, _toDisplayString($setup.Dogspaces.SizeTitle[size]), 9, _hoisted_5))
                }), 128))
              ], 2), [
                [_vModelSelect, $setup.selectedSize]
              ])
            ])
          ])
        ]),
        "header-right": _withCtx(() => [
          _createElementVNode("button", {
            class: "primary icon bulk-edit",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showBulkEdit = true))
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("svg", {
              class: "icon filled bulk-edit",
              viewBox: "0 0 22 22",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                class: "icon filled",
                d: "M2 0C0.9 0 0 0.9 0 2V20C0 21.0 0.9 22 2 22H20C21.0 22 22 21.0 22 20V2C22 0.9 21.0 0 20 0H2ZM2 2H4V4H2V2ZM6 2H8V4H6V2ZM10 2H12V4H10V2ZM14 2H16V4H14V2ZM18 2H20V4H18V2ZM2 6H20V20H2V6ZM5 8C4.86749 7.99813 4.73593 8.02261 4.61296 8.07202C4.48999 8.12143 4.37807 8.1948 4.2837 8.28784C4.18933 8.38088 4.11439 8.49176 4.06324 8.61401C4.0121 8.73627 3.98576 8.86747 3.98576 9C3.98576 9.13253 4.0121 9.26373 4.06324 9.38599C4.11439 9.50824 4.18933 9.61912 4.2837 9.71216C4.37807 9.8052 4.48999 9.87857 4.61296 9.92798C4.73593 9.97739 4.86749 10.0019 5 10H9C9.13251 10.0019 9.26407 9.97739 9.38704 9.92798C9.51001 9.87857 9.62193 9.8052 9.7163 9.71216C9.81067 9.61912 9.88561 9.50824 9.93676 9.38599C9.9879 9.26373 10.0142 9.13253 10.0142 9C10.0142 8.86747 9.9879 8.73627 9.93676 8.61401C9.88561 8.49176 9.81067 8.38088 9.7163 8.28784C9.62193 8.1948 9.51001 8.12143 9.38704 8.07202C9.26407 8.02261 9.13251 7.99813 9 8H5ZM8 12C7.86749 11.9981 7.73593 12.0226 7.61296 12.072C7.48999 12.1214 7.37807 12.1948 7.2837 12.2878C7.18933 12.3809 7.11439 12.4918 7.06324 12.614C7.0121 12.7363 6.98576 12.8675 6.98576 13C6.98576 13.1325 7.0121 13.2637 7.06324 13.386C7.11439 13.5082 7.18933 13.6191 7.2837 13.7122C7.37807 13.8052 7.48999 13.8786 7.61296 13.928C7.73593 13.9774 7.86749 14.0019 8 14H17C17.1325 14.0019 17.2641 13.9774 17.387 13.928C17.51 13.8786 17.6219 13.8052 17.7163 13.7122C17.8107 13.6191 17.8856 13.5082 17.9368 13.386C17.9879 13.2637 18.0142 13.1325 18.0142 13C18.0142 12.8675 17.9879 12.7363 17.9368 12.614C17.8856 12.4918 17.8107 12.3809 17.7163 12.2878C17.6219 12.1948 17.51 12.1214 17.387 12.072C17.2641 12.0226 17.1325 11.9981 17 12H8ZM5 16C4.86749 15.9981 4.73593 16.0226 4.61296 16.072C4.48999 16.1214 4.37807 16.1948 4.2837 16.2878C4.18933 16.3809 4.11439 16.4918 4.06324 16.614C4.0121 16.7363 3.98576 16.8675 3.98576 17C3.98576 17.1325 4.0121 17.2637 4.06324 17.386C4.11439 17.5082 4.18933 17.6191 4.2837 17.7122C4.37807 17.8052 4.48999 17.8786 4.61296 17.928C4.73593 17.9774 4.86749 18.0019 5 18H12C12.1325 18.0019 12.2641 17.9774 12.387 17.928C12.51 17.8786 12.6219 17.8052 12.7163 17.7122C12.8107 17.6191 12.8856 17.5082 12.9368 17.386C12.9879 17.2637 13.0142 17.1325 13.0142 17C13.0142 16.8675 12.9879 16.7363 12.9368 16.614C12.8856 16.4918 12.8107 16.3809 12.7163 16.2878C12.6219 16.1948 12.51 16.1214 12.387 16.072C12.2641 16.0226 12.1325 15.9981 12 16H5Z"
              })
            ], -1),
            _createTextVNode("Bulk Edit")
          ]))
        ]),
        _: 1
      }, 8, ["timeframe", "kennel"])
    ]),
    ($setup.showBulkEdit)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 0,
          onClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.showBulkEdit = false))
        }, {
          default: _withCtx(() => [
            _createVNode($setup["BulkEdit"], {
              "dog-type": $setup.selectedSize,
              onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.showBulkEdit = false))
            }, null, 8, ["dog-type"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}